(function() {
  var container = document.getElementById('recently-viewed-container');
  if (!container) return;

  var maxProducts = 20; // Change this value to define the maximum number of articles to display
  var productId = container.getAttribute('data-product-id');
  var productHandle = container.getAttribute('data-product-handle');
  var productTitle = container.getAttribute('data-product-title');
  var productImage = container.getAttribute('data-product-image');
  console.log('maxProd', maxProducts);

  if (!productId) return;

  var recentProducts = JSON.parse(localStorage.getItem('recently_viewed')) || [];

  // Check if the product is already in the recently viewed products
  var index = recentProducts.findIndex(function(item) {
    return item.id === productId;
  });

  // If the product is not already in the recently viewed products
  if (index === -1) {
    recentProducts.unshift({
      id: productId,
      handle: productHandle,
      title: productTitle,
      image: productImage
    });

    // Limit the number of products in recently viewed products
    if (recentProducts.length > maxProducts) {
      recentProducts.pop();
    }

  // Update localStorage
    localStorage.setItem('recently_viewed', JSON.stringify(recentProducts));
  }

  // Generate the HTML for the "recently viewed" section
  var html = '';
  recentProducts.forEach(function(product) {
    html += '<li class="product-recently__item grid__item">' +
                '<a href="/products/' + product.handle + '">' +
                  '<img src="' + product.image + '" alt="' + product.title + '" loading="lazy">' +
                '</a>' +
              '</li>';
  });

  // Insert the HTML in the "recently viewed" section
  document.getElementById('recently-viewed-products').innerHTML = html;
})();
